import { ListItem, Octopus } from '@maximizer/core/shared/domain';

export interface OutlookAbEntryForm {
  key: string | null;
  firstName: string;
  lastName: string;
  email1Description: string;
  email1: string;
  email2Description?: string;
  email2?: string;
  email3Description?: string;
  email3?: string;
  phone1?: string;
  phone1Description?: string;
  phone2?: string;
  phone2Description?: string;
  phone3?: string;
  phone3Description?: string;
  phone4: string;
  phone4Description: string;
  parentKey: string | null;
  company?: string;
  position?: string;
  website?: string;
  addressKey?: string;
  address1?: string;
  address2?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  country?: string;
  type?: string;
}

export interface OutlookAbEntrySearch {
  key: string | null;
  parentKey: string | null;
  parentType: string | null;
  parentDisplayValue: string | null;
  displayValue: string;
  type: string;
  name: string;
  companyName: string;
  lastContactDateDisplayValue: string;
  lastContactDateValue: string;
  phone1: string;
  phone2: string;
  phone3: string;
}

export interface OutlookAbEntryDetails {
  key: string | null;
  parentKey: string | null;
  parentType: string | null;
  parentDisplayValue: string | null;
  displayValue: string;
  type: string;
  name: string;
  firstName: string;
  lastName: string;
  companyName: string;
  position: string;
  emails: { index: number; type: string; value: string }[];
  phones: { index: number; type: string; value: string }[];
  lastContactDateValue: Date | null;
  website: string;
  address: {
    key: string | Octopus.AddressKey;
    address1: string;
    address2: string;
    zipcode: string;
    city: string;
    provinceState: string;
    country: string;
  } | null;
}

export interface AbEntryFieldOption {
  phoneDescriptions: ListItem<string>[];
  emailDescriptions: ListItem<string>[];
  addressCountry: ListItem<string>[];
}

export enum AbEntryLastContactDatePreference {
  AppointmentCompleted = 'AC',
  TaskCompleted = 'TC',
  EmailSentFromMaximizer = 'EM',
  InteractionLog = 'PH',
  EmailSentFromOutlook = 'EO',
  EmailCampaignSent = 'EC',
  NoteCreated = 'NC',
  UpdateContactParentEntry = 'PA',
}
